import { useCallback, useEffect, useState } from 'react';
import {
  clearStoredAccessKey,
  fetchNseCaricatureBuildInfo,
  getStoredAccessKey,
  verifyNseCaricatureAccess,
} from '../utils/nseCaricatureApi';
import '../../flux-prompt-sample/components/FluxPromptSampleAccessGate.css';

export default function NseCelebrationAccessGate({ children }) {
  const [ready, setReady] = useState(false);
  const [key, setKey] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const [rev, setRev] = useState('');

  useEffect(() => {
    fetchNseCaricatureBuildInfo()
      .then((d) => setRev(d?.rev || ''))
      .catch(() => {});
    if (getStoredAccessKey()) setReady(true);
  }, []);

  const onSubmit = useCallback(
    async (e) => {
      e.preventDefault();
      setBusy(true);
      setError('');
      try {
        await verifyNseCaricatureAccess(key.trim());
        setReady(true);
      } catch (err) {
        setError(err.message || 'Access denied');
        clearStoredAccessKey();
      } finally {
        setBusy(false);
      }
    },
    [key],
  );

  if (ready) return children;

  return (
    <div className="fps-gate">
      <div className="fps-gate-card">
        <h1>NSE IPO celebration poster</h1>
        <p className="fps-gate-lead">
          Upload a portrait — we cartoonize your face (same identity), add the bobblehead body, and place you on
          the NSE template.
        </p>
        <form onSubmit={onSubmit}>
          <label className="fps-gate-label" htmlFor="nse-access-key">Access key</label>
          <input
            id="nse-access-key"
            type="password"
            className="fps-gate-input"
            autoComplete="off"
            value={key}
            onChange={(e) => setKey(e.target.value)}
            placeholder="Same key as FLUX prompt lab"
          />
          <button type="submit" className="fps-gate-btn" disabled={busy || !key.trim()}>
            {busy ? 'Checking…' : 'Continue'}
          </button>
        </form>
        {error ? <p className="fps-gate-error" role="alert">{error}</p> : null}
        {rev ? <p className="fps-gate-rev">rev {rev}</p> : null}
      </div>
    </div>
  );
}
